import { errorToast } from "@/v2-ui/toast"
import Selector from "@/v2-backoffice-client/components/selector"
import type { SelectorTriggerProps } from "@/v2-backoffice-client/components/selector"
import { useLayerQuery } from "@/v2-backoffice-client/layer/layer.query"
import LayerCategoryLayerAddLayerSelectorItem from "@/v2-backoffice-client/layer/category/layer/add/LayerCategoryLayerAddLayerSelectorItem"

export type LayerCategoryLayerAddLayerSelectorProps = SelectorTriggerProps & {
  categoryFeatureCode: string
  existingLayerCodes?: string[]
}

function LayerCategoryLayerAddLayerSelector(
  props: LayerCategoryLayerAddLayerSelectorProps,
) {
  const {
    categoryFeatureCode,
    existingLayerCodes = [],
    ...triggerProps
  } = props

  const { data, loading, error } = useLayerQuery()
  errorToast(error, {
    title: "Failed to query for layers",
  })

  const allLayers = data?.getLayers ?? []
  const availableLayers = allLayers.filter(
    (l) => !existingLayerCodes.includes(l.FeatureCode),
  )

  return (
    <Selector shouldFilter>
      <Selector.Trigger
        iconSrc="plus"
        disabled={triggerProps.disabled ?? availableLayers.length === 0}
        {...triggerProps}
      >
        {triggerProps.children ?? "Add Layer"}
      </Selector.Trigger>

      <Selector.Content>
        <Selector.Search placeholder="Search layers..." debounce={0} />
        <Selector.List
          emptyLabel="No layers found"
          isLoading={loading}
          error={error}
        >
          {availableLayers.map((layer) => (
            <LayerCategoryLayerAddLayerSelectorItem
              key={layer.FeatureCode}
              layer={layer}
              categoryFeatureCode={categoryFeatureCode}
            />
          ))}
        </Selector.List>
      </Selector.Content>
    </Selector>
  )
}

export default LayerCategoryLayerAddLayerSelector
